import { useNavigate } from "react-router-dom";
import { useCounselingStore } from "../../store/counselingStore";
import type { Session } from "../../store/counselingStore";
import client from "../../api/client";

const CATEGORY_LABELS: Record<string, string> = {
  love: "💕",
  career: "💼",
  relationship: "👥",
  money: "💰",
  health: "🌿",
  general: "🔮",
};

function timeAgo(dateStr: string) {
  const diff = Date.now() - new Date(dateStr).getTime();
  const d = Math.floor(diff / 86400000);
  if (d === 0) return "오늘";
  if (d === 1) return "어제";
  if (d < 7) return `${d}일 전`;
  return `${Math.floor(d / 7)}주 전`;
}

interface Props {
  sessions: Session[];
}

export default function RecentHistory({ sessions }: Props) {
  const navigate = useNavigate();
  const { setCurrentSession, setMessages } = useCounselingStore();
  const recent = sessions.slice(0, 3);

  const handleSessionClick = async (s: Session) => {
    setCurrentSession(s);
    try {
      const { data } = await client.get(`/counseling/sessions/${s.id}/messages`);
      setMessages(data);
    } catch {}
    navigate("/counseling");
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-bold text-[var(--color-text-primary)] text-base">
          📋 최근 상담 내역
        </h3>
        {sessions.length > 0 && (
          <button
            onClick={() => navigate("/history")}
            className="text-xs text-[var(--color-accent)] hover:underline font-medium"
          >
            더보기 →
          </button>
        )}
      </div>

      {recent.length === 0 ? (
        <div className="bg-[var(--color-surface)] border border-[var(--color-border-default)] rounded-2xl p-6 text-center">
          <p className="text-2xl mb-2">🏪</p>
          <p className="text-[var(--color-text-tertiary)] text-sm">아직 방문 기록이 없어요</p>
          <p className="text-[var(--color-text-tertiary)] text-xs mt-0.5">
            첫 상담을 시작해보세요! 💬
          </p>
        </div>
      ) : (
        <div className="bg-[var(--color-surface)] border border-[var(--color-border-default)] rounded-2xl overflow-hidden divide-y divide-[var(--color-border-default)]">
          {recent.map((s) => (
            <button
              key={s.id}
              onClick={() => handleSessionClick(s)}
              className="w-full flex items-center gap-3 px-4 py-3 hover:bg-[var(--color-primary)]/20 transition-colors text-left"
            >
              <span className="text-xl flex-shrink-0">
                {CATEGORY_LABELS[s.category]}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-[var(--color-text-primary)] text-sm font-medium truncate">
                  {s.title || "새 상담"}
                </p>
                <p className="text-[var(--color-text-tertiary)] text-xs mt-0.5">
                  {timeAgo(s.updated_at)}
                </p>
              </div>
              <span className="text-[var(--color-text-tertiary)] text-xs flex-shrink-0">→</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
